<template>
  <div
    class="w-full md:w-30rem textPrimary flex flex-column align-items-center justify-content-center"
  >
    <!-- <div class="w-5"> -->
    <h2 class="text-center">Modifique los datos de tipo de efecto</h2>
    <div class="w-2 mb-3 blue-line"></div>

    <div v-if="loading" class="spinner-wrapper">
      <ProgressSpinner style="width: 50px; height: 50px" />
    </div>

    <div v-else>
      <div class="w-full flex flex-column gap-4">
        <div class="flex flex-column align-items-start gap-2">
          <label for="nombre">Ingrese el nombre</label>
          <InputText
            v-no-emoji
            id="nombre"
            v-model="tipoEfecto.nombre"
            class="w-full input-border-blue"
          />
        </div>

        <div class="flex flex-column align-items-start gap-2">
          <label for="subCategoria">Seleccione una sub-categoría </label>
          <Dropdown
            id="subCategoria"
            v-model="tipoEfecto.id_subcategoria"
            :options="subcategorias"
            @change="changeDropdown"
            optionLabel="Nombre"
            optionValue="SubcategoriaID"
            :filter="true"
            placeholder="Seleccione"
            class="w-full input-border-blue"
          />
        </div>
      </div>

      <div class="mt-5 flex justify-content-start gap-2">
        <Button label="Cancelar" @click="handleCancel" class="cancelar-button" />
        <Button
          label="Confirmar"
          :icon="isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
          @click="handleSave"
          :disabled="isSaving"
          class="custom-action-button"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onBeforeMount, defineComponent } from "vue";
import { useStoreCompat } from "@/composables/useStoreCompat.js";
import { useRest } from "@/composables/useRest";

export default defineComponent({
  name: "TipoEfectoForm",
  props: {
    tipoEfectoData: Object,
  },
  emits: ["close", "openModalsuccess"],
  setup(props, { emit }) {
    const store = useStoreCompat();
    const rest = useRest();

    const modalSuccess = ref(null);
    const tipoEfecto = ref({
      nombre: props.tipoEfectoData?.nombre || "",
      id_subcategoria: props.tipoEfectoData?.id_subcategoria || null,
      subcategoria: props.tipoEfectoData?.subcategoria || "",
    });

    const loading = ref(true);
    const isSaving = ref(false);
    const tipoID = ref(props.tipoEfectoData.tipoID);

    const subcategorias = computed(() => store.state.siis.subcategoriasDeposito);

    const changeDropdown = (event) => {
      const selected = event.value;
      const found = subcategorias.value.find((sub) => sub.SubcategoriaID === selected);
      tipoEfecto.value.subcategoria = found?.Nombre || "";
    };

    const handleSave = async () => {
      isSaving.value = true;
      try {
        await rest.put({
          url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/parametros/tipo-depositos/${tipoID.value}`,
          formData: {
            nombre: tipoEfecto.value.nombre,
            id_subcategoria: tipoEfecto.value.id_subcategoria,
          },
        });
        emit("openModalsuccess", {
          title: "Los datos de tipo efecto fueron editados",
          message: "Ahora se veran reflejados tus nuevos datos en la tabla",
        });
        emit("close");
      } catch (err) {
        console.error("Error al guardar:", err);
      } finally {
        isSaving.value = false;
      }
    };

    const handleCancel = () => {
      emit("close");
    };

    onBeforeMount(async () => {
      await store.dispatch("siis/setSubCategoriasDeposito");
      await store.dispatch("siis/setTipoDeposito");
      loading.value = false;
    });

    return {
      //refs
      modalSuccess,
      tipoEfecto,
      loading,
      isSaving,
      tipoID,
      //computetd
      subcategorias,
      //methods
      handleSave,
      changeDropdown,
      handleCancel,
    };
  },
});
</script>

<style scoped>
.textPrimary {
  color: #111928;
}

.blue-line {
  height: 4px;
  background-color: #0b5195;
  border-radius: 9999px;
}

.custom-action-button {
  display: flex;
  width: 124px;
  height: 36px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 6px;
  background-color: var(--Primary, #0b5195);
  color: white;
  border: none;
}

.custom-action-button:hover {
  opacity: 0.9;
  cursor: pointer;
}

.cancelar-button {
  display: flex;
  width: 124px;
  height: 36px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 6px;
  background: var(--White-White, #fff);
  color: #0b5195;
  border: none;
  box-shadow: 0px 1px 3px 0px rgba(166, 175, 195, 0.4);
}

.cancelar-button:hover {
  background: #f4f4f4 !important;
  color: #0b5195 !important;
  opacity: 0.9;
  cursor: pointer;
}

.input-border-blue {
  border: 2px solid #0b5195;
  border-radius: 6px;
  width: 100%;
  transition: border 0.2s ease;
}
</style>
